import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  wapperPropretySpecification: {
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  containerTopSection: {
    display: "flex",
    flexDirection: "column",
  },
  containerHeader: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingBottom: "20px",
  },
  containerBody: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  rowItem: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  containerTopRow: {
    display:'flex',
    flexDirection:'row',
    alignItems:'center',
    gap:'8px'
  },
  containerBottomRow: {
    display:'flex',
    flexDirection:'row',
    alignItems:'center',
    gap:'8px'
  }
}));
